module.exports = __webpack_public_path__ + "static/img/landing-rate.9b64c02.svg";